/**
 * @file
 * Text Tile script.
 */

(function textTileScript($, Drupal) {
  'use strict';
  Drupal.behaviors.textTileTarget = {
    attach: function (context) {
      var $clickZone = $('.js-text-tile--click-zone', context);

      $clickZone.each(function () {
        var $target = $('a', $(this)).first();
        $target.bigTarget({
          clickZone: '.js-text-tile--click-zone',
          clickZoneClass: 'js-text-tile',
          anchorClass: 'js-text-tile__target'
        });
      });
    }
  };
}(jQuery, Drupal));
